import React, { useState, useEffect } from "react";
import NotificationCard from "../components/Notification/NotifiactionCard";
import API from "../network/redAPI";
import { useCart } from "../contexts/cart/use-cart";
import CartPopUp from "../containers/Cart/CartPopUp";
import { useDeviceType } from "../helper/useDeviceType";

const NotificationPage = (props, { userAgent }) => {
	const { fetchOrderItems } = useCart();
	const deviceType = useDeviceType(userAgent);
	//state
	const [notification, setNotification] = useState({});
	const [loading, setLoading] = useState(true);

	const user = JSON.parse(localStorage.getItem("user"));
	const notification_id = window.location.pathname.split("/")[2];

	if (user === null) {
		window.location.href = "/";
	}

	useEffect(() => {
		if (user && notification_id) {
			fetchOrderItems(localStorage.getItem("expressMode") ? "express" : "normal");
			API.GetNotification({ notification_id: notification_id })
				.then((res) => res.json())
				.then((data) => {
					if (data.success) {
						setNotification(data.data);
					}
					setLoading(false);
				});
		} else {
			setLoading(false);
		}
	}, []);

	return (
		<>
			<NotificationCard notification={notification} loading={loading} />

			<CartPopUp deviceType={deviceType} />
		</>
	);
};
export default NotificationPage;
